var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.33 20.506 7.176-7.176a1.69 1.69 0 0 0 0-2.387l-7.45-7.449C12.785 3.221 12.25 3 11.865 3H4.687C3.756 3 3 3.756 3 4.687v7.177c0 .385.221.92.494 1.193l7.45 7.449a1.69 1.69 0 0 0 2.386 0m-1.193-1.194-7.45-7.448V4.687h7.177l7.448 7.45zM8.062 9.75a1.687 1.687 0 1 0 0-3.375 1.687 1.687 0 0 0 0 3.375"
  })));
};
export default SvgTag;